 
 
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
 const store = new Vuex.Store({
    state: {
      openidText: "",
    },
    mutations: {
        increment (state,text) {
          state.openidText=text;
        }
    }
  });
 
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js